<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Видео обучения</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link to="/teaching-videos/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Добавить видео
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Список видео обучения</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="teachingVideosList" :fields="tableFields">
                <template #cell(title)="row">
                  <div v-html="row.item.title"></div>
                </template>
                <template #cell(image_paths)="row">
                  <div v-if="row.item.image_paths">
                    <img class="img-thumbnail table-image" :src="row.item.image_paths.small" alt="image">
                  </div>
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`/teaching-videos/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="removeTeachingVideo(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restTeachingVideo(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="removeTeachingVideo(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'TeachingVideos',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      teachingVideosList: state => state.teachingVideo.teachingVideosList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'image_paths',
          label: 'Фото',
          sortable: true
        },
        {
          key: 'title.' + this.$i18n.locale,
          label: 'Название',
          sortable: true
        },
        {
          key: 'description.' + this.$i18n.locale,
          label: 'Описание',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Действие',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getVideos({})
  },
  methods: {
    ...mapActions({
      getAllTeachingVideos: 'teachingVideo/getAllTeachingVideos',
      deleteTeachingVideo: 'teachingVideo/deleteTeachingVideo',
      restoreTeachingVideo: 'teachingVideo/restoreTeachingVideo'
    }),
    getVideos (params) {
      this.getAllTeachingVideos(params).then(res => {
        this.pagination = res.pagination
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    changePaginationPerPage (value) {
      this.getVideos({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getVideos({ page: page, count: this.paginationPerPage })
    },
    removeTeachingVideo (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteTeachingVideo({ id }).then(res => {
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restTeachingVideo (id) {
      this.restoreTeachingVideo({ id }).then(res => {
      })
    }
  }
}
</script>
